<template>
  <div
    :style="style"
    class="badge-notification"
    :class="[{ visible: count > 0 }, `theme-${theme}`]"
  >
    <transition name="fade" mode="out-in">
      <span :key="count">{{ count }}</span>
    </transition>
  </div>
</template>

<script setup lang="ts">
interface Props {
  count: number;
  theme?: string;
}
const props = defineProps({
  count: null,
  theme: { default: 'default' }
});

const { style, scale } = useScaleEffect(props.count > 0 ? 1 : 0, false, 8, 300);

watch(
  () => props.count,
  (val) => {
    scale.value = val > 0 ? 1 : 0;
  }
);
</script>

<style lang="scss" scoped>
.badge-notification {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  transition: opacity 600ms $ease-in-quad;
  border-radius: 50%;
  opacity: 0;
  background-color: var(--color_secondary);
  &.theme-red {
    background-color: #d02d2d;
  }

  color: white;
  &.visible {
    transition: opacity 100ms $ease-out-quad;
    opacity: 1;
  }
  @include font('xxs', 800, 'secondary');
  @include above('l') {
    width: 2.5rem;
    height: 2.5rem;
    @include font('xxs', 600, 'secondary');
  }
}
</style>
